"use client";

import { useEffect } from "react";
import { useAuthStore } from "@/store/authStore";
import { initializeNativeCaptureRecovery, reportNativeCaptureRecovery } from "@/services/nativeCaptureService";

/**
 * Inicializa a sessão do usuário (hydrate) ao montar a app.
 * Coloque este componente **uma vez** no layout raiz, envolvendo {children}.
 *
 * Não bloqueia a renderização — apenas seta `hydrated = true`
 * para que guards downstream decidam se redirecionam.
 */
export function AuthProvider({ children }: { children: React.ReactNode }) {
  const hydrate = useAuthStore((s) => s.hydrate);

  useEffect(() => {
    void initializeNativeCaptureRecovery()
      .catch(reportNativeCaptureRecovery)
      .then(() => hydrate());
  }, [hydrate]);

  return <>{children}</>;
}
